import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, serverTimestamp } from 'firebase/firestore'


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCEDydpOXbUo8U9J0iomb2NC0SEaO9mNMg",
  authDomain: "my-portfolio-b0a06.firebaseapp.com",
  projectId: "my-portfolio-b0a06",
  storageBucket: "my-portfolio-b0a06.appspot.com",
  messagingSenderId: "778685999231",
  appId: "1:778685999231:web:52c670b0268bf5b59c374a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth
const auth = getAuth(app)

// Auth
const timestamp = serverTimestamp(app)

// db
const db = getFirestore(app);

export { auth, db, timestamp }